import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getPointCard } from 'reducks/pointCard/selectors'
import { fetchPointCardUsers } from 'repos/pointCard/pointCardUser'
import { PointCardUserType as BasePointCardUserType } from 'types/pointCard/pointCardUser'
import { FirebaseDocRefType } from 'firebase/index'
type PointCardUserType = BasePointCardUserType & { ref: FirebaseDocRefType }

const useFetchPointCardUsers = () => {
  const pointCard = useSelector((state: State) => getPointCard(state))
  const [pointCardUsers, setPointCardUsers] = useState<PointCardUserType[]>([])

  useEffect(() => {
    ;(async () => {
      if (!pointCard) return
      const res = await fetchPointCardUsers(pointCard.ref.id)
      if (!res) return
      setPointCardUsers(res)
    })()
  }, [pointCard])

  return {
    pointCardUsers,
  }
}

export default useFetchPointCardUsers
